import React from "react";

import { string, node } from "prop-types";

import { Typography } from "clearsense-ui/components";
import { Scribbles } from "icons";

const EmptyState = ({ illustration, mainText, description, actionBlock }) => (
  <div className="flex justify-center h-full items-center flex-col w-full">
    {illustration || <Scribbles />}
    <Typography style="h3" type="semibold" className="mb-3 mt-2.5">
      {mainText}
    </Typography>
    <Typography type="medium" className="max-w-sm text-center mb-6">
      {description}
    </Typography>
    {actionBlock}
  </div>
);

EmptyState.propTypes = {
  mainText: string,
  description: string,
  illustration: node,
  actionBlock: node,
};

export default EmptyState;
